import {BaseContainerModel} from '../../base-container.model';

export class TopicMemberLabelLinkContainerModel extends BaseContainerModel {
  websiteCode: string;
  tenantCode: string;
  memberLabel: string;
  topicsToSubscribe: string[];
  topicsToUnSubscribe: string[];
  limit: number;
  executionInterval: string;
}
